/* eslint-disable no-console */
import { clientSideFeatureToggles } from '../featureToggle/clientSideFeatureToggles';

export const trace = (...args: any[]) => {
    const isTracingEnabled = import.meta.env.MODE !== 'production' || clientSideFeatureToggles.enableConsoleTracing;
    if (isTracingEnabled) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        console.log('[outbound-web-app]', ...args);
    }
};
